import axios from 'axios';
import store from '@/store/index';
import $config from '@/config/index';
import userModel from '@/libs/userModel';

import QS from 'qs';

const client = axios.create();

// 线上环境配置axios.defaults.baseURL，生产环境则用proxy代理
if (process.env.NODE_ENV !== 'development') {
  client.defaults.baseURL = $config.baseURL;
}
client.defaults.headers['Content-Type'] = 'application/json;charse=UTF-8';
client.defaults.headers['Cache-Control'] = 'no-cache';
client.defaults.timeout = 29000; // 超时时间

/**
 * 下载文件
 */
let downloadFile = (url) => {
  window.open(url);
};

// 当前的错误信息，防止同个错误信息多次提醒
let curErrMsg = '';
let messageTimer = null;

//请求拦截器
client.interceptors.request.use(
  (config) => {
    config.headers.appId = store.state.currentAppCode;
    config.headers.remote_user = store.getters.oauth.userCode;
    config.headers.version = $config.version || '';
    config.headers.Authorization =
      config.headers.Authorization || store.getters.authorization;
    config.headers['Access-Control-Allow-Origin'] = '*';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//响应拦截器即异常处理
client.interceptors.response.use(
  (response) => {
    const { headers = {} } = response.config;
    const { _showCommonMsg = true } = headers;
    if (response && response.request && response.request.responseType === 'blob') {
      return Promise.resolve(response.data);
    }else if (response.data.status) {
      return Promise.resolve(response.data);
    } else {
      // 防重
      let msg =
        response.data.message || response.data.msg || response.data.errMsg;
      if (_showCommonMsg) {
        if (curErrMsg != msg) {
          curErrMsg = msg;
          _showCommonMsg && store.dispatch('showMessage', {
            type: 'error',
            message: msg,
          });
          messageTimer = setTimeout(() => {
            curErrMsg = '';
          }, 2900);
        } else {
          messageTimer && clearTimeout(messageTimer);
          messageTimer = setTimeout(() => {
            curErrMsg = '';
          }, 2900);
        }
      }
      return Promise.reject(response.data);
    }
  },
  (err) => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '错误请求';
          break;
        case 401:
          err.message = '未授权，请重新登录';
          // 跳转登录页面
          // 接口410， 逻辑处理
          userModel._goLoginRedirectToUserCenterSso();
          break;
        case 403:
          err.message = '没有访问权限，拒绝访问';
          break;
        case 404:
          err.message = '请求错误,未找到该资源';
          break;
        case 405:
          err.message = '请求方法未允许';
          break;
        case 500:
          err.message = err.response.data.message || '服务器端出错';
          break;
        default:
          err.message = err.response.msg ? `连接错误${err.response.msg}` : '连接错误';
      }
    } else {
      // 处理网络超时
      if (err.code === 'ECONNABORTED' || err.message ===  "Network Error" ||  err.message.includes("timeout")) {
        err.message = '网络请求超时，请稍后刷新再试';
      } else {
        err.message = '连接到服务器失败';
      }
    }
    if ((err.response && err.response.status !== 401) || !err.response) {
      // 防重
      const msg = err.message || err.response.msg;
      if (curErrMsg != msg) {
        curErrMsg = msg;
        store.dispatch('showMessage', {
          type: 'error',
          message: msg,
        });
        messageTimer = setTimeout(() => {
          curErrMsg = '';
        }, 2900);
      } else {
        messageTimer && clearTimeout(messageTimer);
        messageTimer = setTimeout(() => {
          curErrMsg = '';
        }, 2900);
      }
    }
    return Promise.reject(err);
  }
);

export default {
  //get请求
  get(url, param, header, responseType) {
    return client({
      method: 'get',
      url,
      headers: {
        ...(header || {}),
      },
      responseType,
      params: param || {},
    });
  },
  //post请求
  post(url, param, header, options) {
    return client({
      method: 'post',
      url,
      headers: {
        ...(header || {}),
        'Content-Type': 'application/json;charse=UTF-8',
      },
      data: param || {},
      ...(options || {}),
    });
  },
  //post请求
  put(url, param, header) {
    return client({
      method: 'put',
      url,
      headers: {
        ...(header || {}),
        'Content-Type': 'application/json;charse=UTF-8',
      },
      data: param || {},
    });
  },
  // delete
  delete(url, param, header) {
    return client({
      method: 'delete',
      url,
      headers: {
        ...(header || {}),
      },
      params: param || {},
    });
  },
  //post请求
  postFormData(url, param, header) {
    return client({
      method: 'post',
      url,
      headers: {
        ...(header || {}),
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: QS.stringify(param) || {},
    });
  },
  uploadFile(url, params, header) {
    let data = new FormData();
    for (let key in params) {
      data.append(key, params[key]);
    }
    return client({
      method: 'post',
      url: `${url}`,
      data: data,
      timeout: 60000 * 10,
      headers: {
        ...header,
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  // 此方法非promise 导出文件
  getFile(url, params) {
    let token = store.getters.authorization;
    token = token.replace('Bearer ', '');
    let tempParams = {
      ...(params || {}),
      token: token,
    };
    // 拼接下载地址
    let list = [];
    for (let key in tempParams) {
      list.push(key.toString() + '=' + tempParams[key]);
    }
    url = /^http(s?):\/\//.test(url) ? url : $config.baseURL + url;
    url = list.length ? url + '?' + list.join('&') : url;
    url = encodeURI(url);
    downloadFile(url);
  },
};
